import React from 'react';
import { Text, TextProps } from '@nimbus-ds/components';

interface FormattedMultilineTextProps extends TextProps {
  children: string;
  formattedFontWeight?: TextProps['fontWeight'];
}

export function FormattedMultilineText({
  children,
  formattedFontWeight = 'medium',
  ...rest
}: FormattedMultilineTextProps) {
  const parseLine = (line: string, lineIndex: number) => {
    const parts = line.split(/(<b>.*?<\/b>)/g).filter(Boolean);

    return (
      <Text key={`${lineIndex}-${line}`} {...rest}>
        {parts.map((part, partIndex) => {
          const boldMatch = part.match(/^<b>(.*?)<\/b>$/);
          if (boldMatch) {
            return (
              <Text
                {...rest}
                as="span"
                fontWeight={formattedFontWeight}
                key={`${lineIndex}-${partIndex}-${part}`}
              >
                {boldMatch[1]}
              </Text>
            );
          }
          return <span key={`${lineIndex}-${partIndex}-${part}`}>{part}</span>;
        })}
      </Text>
    );
  };

  return (
    <>
      {children
        .split('\n')
        .filter((s) => !!s)
        .map((line, index) => parseLine(line, index))}
    </>
  );
}
